import React from "react";

type Props = {
  items: any[];
  children: React.ReactNode;
  emptyState?: string | React.ReactNode;
};

const EmptyCheck = ({ items, children, emptyState = "Empty" }: Props) => {
  return items?.length === 0 ? (
    <div
      style={{
        textAlign: "center",
        background: "#FFF",
        padding: "8px",
        margin: "8px 0",
      }}
    >
      {emptyState}
    </div>
  ) : (
    <>{children}</>
  );
};

export default EmptyCheck;
